var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.2754C3.75 9.43964 3.75 9.02177 3.85513 8.63517C3.94828 8.29266 4.10146 7.96939 4.30757 7.68041C4.54021 7.35423 4.86363 7.08962 5.51046 6.56039L8.96046 3.73766C10.0433 2.85166 10.5848 2.40866 11.1874 2.2391C11.7188 2.08957 12.2812 2.08957 12.8126 2.2391C13.4152 2.40866 13.9567 2.85166 15.0395 3.73766L18.4895 6.56039C19.1364 7.08962 19.4598 7.35423 19.6924 7.68041C19.8985 7.96939 20.0517 8.29266 20.1449 8.63517C20.25 9.02177 20.25 9.43964 20.25 10.2754V15.4508C20.25 17.1309 20.25 17.971 19.923 18.6127C19.6354 19.1772 19.1765 19.6362 18.612 19.9238C17.9702 20.2508 17.1302 20.2508 15.45 20.2508H8.55C6.86984 20.2508 6.02976 20.2508 5.38803 19.9238C4.82354 19.6362 4.3646 19.1772 4.07698 18.6127C3.75 17.971 3.75 17.1309 3.75 15.4508V10.2754Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 16.25H16.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.cb259ab70a17109c25bbdcb8634bf3af.svg";
export { ForwardRef as ReactComponent };